import { render } from "./NumberGrow.vue?vue&type=template&id=1584a2d8"
import script from "./NumberGrow.vue?vue&type=script&lang=js"
export * from "./NumberGrow.vue?vue&type=script&lang=js"

import "./NumberGrow.vue?vue&type=style&index=0&id=1584a2d8&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/pro-base3-fe-portal-old1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__